//
import styled from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

const OneHrFilterWrapper = styled.div`
  display: flex;
  gap: 10px;
  background-color: ${(props) => props.theme.colors.WHITE};
  flex: 1;

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXM};
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XXM};
  }

  &#one-hr-filter.one-hr-filter-redesign {
    flex: 0 0 auto;
    margin: 12px 0 20px;
    padding: 0;

    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 0;
      ${({ isBopisEmptyResults }) => isBopisEmptyResults && 'padding-bottom: 16px;'}
    }

    .one-hr-filter-toggle-switch-redesign {
      width: unset;
      height: unset;
    }

    .toggle-switch-label {
      width: 20px;
      height: 20px;
      border-radius: 4px;
      border: 1px solid #000;
      overflow: hidden;
      margin: 0;

      @media ${(props) => props.theme.mediaQuery.large} {
        width: 24px;
        height: 24px;
      }
    }

    .toggle-switch-checkbox:checked + .toggle-switch-label {
      background: black url('${(props) => getIconPath('tick-mark', props)}') no-repeat center center;
    }

    .toggle-switch-switch,
    .toggle-switch-inner {
      display: none;
    }

    .one-hr-filter-text-area {
      display: flex;
      align-items: center;
      column-gap: 6px;
      max-width: unset;
      overflow: hidden;
    }

    .store-change-wrapper,
    .change-store-link {
      min-width: 0;
    }

    .one-hr-filter-text-area-label {
      white-space: nowrap;
      color: #000;
      font-size: 12px;
      font-weight: 600;
      line-height: 150%;
      text-transform: capitalize;

      @media ${(props) => props.theme.mediaQuery.large} {
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.5px;
      }
    }

    .change-store-link {
      margin: 0;
    }

    .change-store-link p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #005d95;
      font-size: 12px;
      font-weight: 600;
      line-height: 150%;
      text-decoration-line: underline;
      text-decoration-skip-ink: none;
      text-transform: capitalize;

      @media ${(props) => props.theme.mediaQuery.large} {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0.5px;
        ${({ isBopisEmptyResults }) => !isBopisEmptyResults && 'max-width: 30ch;'}
      }
    }
  }
`;

export const OneHrFilterTextArea = styled.div`
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    max-width: 70%;
  }
`;

export const DefaultStoreMessage = styled.span`
  font-weight: 700;
`;

export const PickupLabel = styled.span`
  font-weight: 600;
`;

export default OneHrFilterWrapper;
